// Tracks whether a client has completed the first-visit onboarding tour
// (public review page only). Same global-key, try/catch-guarded pattern as
// clientName.ts. localStorage is the primary store so "seen" survives across
// sessions and scripts in a bundle; if it's unavailable (private mode /
// blocked), sessionStorage is a fallback so a storage-blocked visitor is at
// worst hard-gated once per tab session rather than on every reload.
//
// Bump the suffix (_v2, _v3, ...) to force a re-show after a tour change
// significant enough to justify re-gating every returning client — a content
// tweak doesn't warrant it.

const KEY = 'hsp_onboarding_seen_v1';

export function hasSeenOnboarding(): boolean {
  try {
    if (localStorage.getItem(KEY) === '1') return true;
  } catch {
    /* fall through to sessionStorage */
  }
  try {
    return sessionStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

export function markOnboardingSeen(): void {
  try {
    localStorage.setItem(KEY, '1');
    return;
  } catch {
    /* fall through to sessionStorage */
  }
  try {
    sessionStorage.setItem(KEY, '1');
  } catch {}
}
